import cx from "classnames";
import capitalize from "lodash-es/capitalize";

import Counter from "ds/components/Counter";
import TextEllipsis from "ds/components/TextEllipsis";
import Tree, {
  TreeBranch,
  TreeBranchLink,
  TreeItem,
  TreeItemContent,
  TreeItemToggle,
} from "ds/components/Tree";
import Typography from "ds/components/Typography";
import { useToggle } from "hooks/useToggle";

import HistoryEntryLabel from "../HistoryEntryLabel";
import styles from "./styles.module.css";

type RunPhaseLogsHooksProps = {
  hooks: string[] | undefined;
  type: "before" | "after";
};

const RunPhaseLogsHooks = ({ type, hooks }: RunPhaseLogsHooksProps) => {
  const [isOpen, toggle] = useToggle(false);

  if (!hooks || hooks.length === 0) {
    return null;
  }

  return (
    <TreeBranch>
      <TreeBranchLink>
        <TreeItem gap="medium" padding="small" autoHeight>
          <TreeItemToggle onPress={() => toggle()} isExpanded={isOpen}>
            {isOpen ? "Collapse" : "Expand"}
          </TreeItemToggle>
          <TreeItemContent gap="medium">
            <HistoryEntryLabel>
              Hooks <i>{capitalize(type)}</i>
            </HistoryEntryLabel>

            <Counter size="small" count={hooks.length} />
          </TreeItemContent>
        </TreeItem>
      </TreeBranchLink>
      {isOpen && (
        <Tree margin="0 0 large 0">
          {hooks.map((hook, index) => (
            <TreeBranch key={index}>
              <TreeBranchLink padding="small 0">
                <TreeItem autoHeight align="start">
                  <TextEllipsis tooltip={hook}>
                    {({ className, ...props }) => (
                      <Typography
                        variant="s-body3"
                        tag="span"
                        className={cx(styles.hook, className)}
                        {...props}
                      >
                        {hook}
                      </Typography>
                    )}
                  </TextEllipsis>
                </TreeItem>
              </TreeBranchLink>
            </TreeBranch>
          ))}
        </Tree>
      )}
    </TreeBranch>
  );
};

export default RunPhaseLogsHooks;
